import { Layout } from 'common/components/Layout/Layout'
import { ReactElement } from 'react'

/** `getLayout` for community pages: app shell for candidates, bare landing page for everyone else. */
export const getCommunityLayout = (page: ReactElement) => (page.props?.isCandidate ? <Layout>{page}</Layout> : page)
